
export class LeaseFieldNames {
    static HORSE_ID = "horseId";
    static LESSEE_ID = "lesseeId";
    static LEASE_START_DATE = "leaseStartDate";
    static LEASE_END_DATE = "leaseEndDate";
    static CAN_PARTICIPATE_BEAUTY = "canParticipateInBeautyChampionships";
    static CAN_COVER_REGISTER = "canCoverAndRegisterFoals";
    static CAN_REGISTER_OTHER = "canRegisterFoalsForOtherOwners";
    static CAN_IMPORT_EXPORT = "canImportAndExport";
    static IS_MARE_COVERED = "isMareCovered";
    static LESSEE_COMMENT = "lesseeComment";
    static DOC_TYPE_DROP = "documentTypeDrop";
    static ATTACHMENT_FILE = "attachmentFile";
    static HORSE_ORIGIN = "horseOrigin";
    static HORSE_BREEDER = "horseBreeder";
    static HORSE_GENDER_DISPLAY = "horseGenderDisplay";
    static HORSE_GENDER = "horseGender";
    static HORSE_COLOR = "horseColor";
    static HORSE_BIRTH_DATE = "horseBirthDate";
    static HORSE_SIRE = "horseSire";
    static HORSE_DAM = "horseDam";
    static COVERING_CERT_NO = "coveringCertificateNo";
    static STALLION_NAME = "stallionName";
    static LESSEE_MOBILE = "lesseeMobile";
    static LESSEE_ID_NUMBER = "lesseeIdNumber";
    static LESSEE_EMAIL = "lesseeEmail";
    static COMMENT = "comment";
    static COVERING_DATE = "coveringDate";
}

